<template>
  <div id="app">
    <ProgressBar></ProgressBar>
    <header class="header">
      <Logo />
    </header>
    <component
      v-for="(chapter, index) in chapters"
      :key="index"
      :is="chapter.component"
      :track="chapter.track"
    ></component>
  </div>
</template>

<script>
import 'reset-css'
import { Logo } from './components/icons'
import ProgressBar from './components/ProgressBar'
import { Intro, Chapter1, Chapter2, Chapter3, Chapter4, Chapter5, Stemwijzer, Footer } from './components/chapters'

export default {
  name: 'app',
  data () {
    return {
      chapters: [].concat({
        component: Intro,
        track: '00-intro'
      }, {
        component: Chapter1,
        track: '01-ridders-boeren-en-steden'
      }, {
        component: Chapter2,
        track: '02-wie-is-geschikt'
      }, {
        component: Chapter3,
        track: '03-niet-meer-alleen-voor-de-allerrijksten'
      }, {
        component: Chapter4,
        track: '04-het-gezond-verstand'
      }, {
        component: Chapter5,
        track: '05-einde-discussie'
      }, {
        component: Stemwijzer,
        track: '06-stemwijzer'
      }, {
        component: Footer,
        track: '07-footer'
      })
    }
  },
  components: {
    ProgressBar,
    Logo
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: absolute;
  top: 27px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 1;
}
</style>

<style lang="scss">
*,
*::before,
*::after {
  box-sizing: border-box;
}

#app {
  background-color: white;
  font-size: $fs-normal;
  line-height: $lh-normal;
  font-family: $ff-barlow;
  color: $c-text;
  overflow-x: hidden;
}

i {
  font-style: italic;
}

.is-fading-element {
  opacity: 0;
  transform: translateY(25px);
  transition: all 3s cubic-bezier(.19,1,.22,1);
  transition-property: transform, opacity;
  will-change: transform, opacity;
}

.is-fading-element-appear {
  opacity: 1;
  transform: translateY(0px);
}

.container {
  @extend %container;
}

.bg-red {
  background-color: $c-red;
}

.bg-blue {
  background-color: $c-blue;
}

.bg-white {
  background-color: white;
}

.bg-light {
  background-color: $c-light;
}

.bg-dark {
  background-color: $c-dark;
}

.bg-yellow {
  background-color: #FFC828;
}
</style>
